import axios from 'axios';
import { Action, Mutation } from '../types';
import { Mutation as SessionMutation } from '../../session/types';

export default {
  [Action.GET_USER_DATA]({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_API_URL + 'users')
        .then((resp) => {
          commit(`${Mutation.SET_USER}`, resp.data.data);
          commit(`${Mutation.SET_ORGANISATION}`, resp.data.data.organisation);
          commit(`${Mutation.SET_SUBSCRIPTION}`, resp.data.data.subscription);
          resolve(resp);
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              commit(`${SessionMutation.LOGOUT}`);
            }
          }
          reject(err);
        });
    });
  }
};
